export const apiError = (error, fallback = 'The request could not be completed.') => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map(item => item.msg || 'Invalid input').join(' ');
  return detail?.message || fallback;
};